import { QBox } from '@qualio/ui-components';
import { useContext } from 'react';
import { handleSidebarClick } from '../../../../util/SidebarUtils';
import {
  DocumentOverviewContext,
  EditorStatus,
  EditorStatusContext,
} from '../Context';
import styles from './QMultiRootEditor.module.css';

type CommentSidebarProps = {
  id: 'commentsSidebar' | 'changeControlSidebar';
};

export const CommentSidebar = ({ id }: CommentSidebarProps) => {
  const { docEditorStatus } = useContext(EditorStatusContext);
  const { commentsPermission } = useContext(DocumentOverviewContext);
  return (
    <QBox
      className={styles['document-sidebar']}
      style={{
        minWidth: commentsPermission > 0 ? '48px' : '0px',
      }}
    >
      <QBox
        onMouseDown={handleSidebarClick}
        flexShrink={1}
        id={id}
        data-cy={id}
        className={`${
          docEditorStatus === EditorStatus.CONNECTING ? 'ck-hidden' : ''
        } transition_on_click`}
      />
    </QBox>
  );
};
